import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex: 1;
	gap: var(--spacing-small);
	align-items: center;
	min-width: 0;
`;
